import React, { useState, useEffect } from 'react';
import LessonShell from '../../../Components/LessonShell';
import RelatedExercises from '../../../Shared/relatedExercises';
import DOMPurify from 'dompurify';
import QuestionCarousel from '../../../Shared/Components/QuestionCarousel';
import { addTooltipsToText } from '../../../Shared/tooltipUtils.jsx';
import { FaAngleDown } from 'react-icons/fa';
import './reading-page.css';

const ReadingContent = ({ data }) => {
  const [answers, setAnswers] = useState([]);
  const [showResults, setShowResults] = useState(false);
  const [isVocabVisible, setIsVocabVisible] = useState(false);

  const allQuestions = data.paragraphs?.flatMap(p => p.questions || []) || [];

  useEffect(() => {
    if (allQuestions.length) {
      setAnswers(Array(allQuestions.length).fill(''));
    }
  }, [allQuestions.length]);

  const handleAnswerChange = (questionIndex, choice) => {
    const updated = [...answers];
    updated[questionIndex] = choice;
    setAnswers(updated);
    setShowResults(false);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setShowResults(true);
  };

  const toggleVocab = () => setIsVocabVisible((prev) => !prev);

  if (!data) {
    return <div>Loading reading...</div>;
  }

  return (
    <div className="reading-page-content">
      {/* Reading image */}
      <div className="reading-image">
        <img src={data.image} alt={data.readingcompTitle} />
      </div>

      {/* Vocabulary section - simple toggle */}
      {data.vocabulary && data.vocabulary.length > 0 && (
        <div className="reading-vocab-section">
          <div className="reading-vocab-header" onClick={toggleVocab}>
            <span>Vocabulary ({data.vocabulary.length})</span>
            <FaAngleDown className={isVocabVisible ? 'rotated' : ''} />
          </div>
          {isVocabVisible && (
            <div className="reading-vocabulary">
              <ul>
                {data.vocabulary.map((item, idx) => (
                  <li key={idx} dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(item) }} />
                ))}
              </ul>
            </div>
          )}
        </div>
      )}

      {/* Reading text */}
      <div className="reading-text">
        {data.paragraphs?.map((p, idx) => {
          const textContent = Array.isArray(p.text)
            ? p.text.join('')
            : p.text || '';
          return (
            <div
              key={idx}
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(addTooltipsToText(textContent, data.vocabulary)),
              }}
            />
          );
        })}
      </div>

      {/* Questions Carousel - using shared component */}
      {allQuestions.length > 0 && (
        <QuestionCarousel
          questions={allQuestions}
          answers={answers}
          onAnswerChange={handleAnswerChange}
          onSubmit={handleSubmit}
          showResults={showResults}
          customIcons={true}
          submitLabel="Check Answer"
        />
      )}
    </div>
  );
};

const ReadingPageLayout = ({
  level,
  title,
  image,
  readingData,
  seoTitle,
  seoDescription,
  relatedCategory,
  relatedLevel,
}) => {
  const panels = [
    {
      label: 'Reading',
      title: 'Read the text',
      content: <ReadingContent data={readingData} />,
    },
  ];

  return (
    <LessonShell
      eyebrow="Reading"
      title={title}
      image={image}
      level={level}
      description={readingData.description}
      seoTitle={seoTitle}
      seoDescription={seoDescription}
      seoName="English Exam Exercises"
      panels={panels}
    >
      <RelatedExercises
        currentCategory={relatedCategory}
        currentLevel={relatedLevel}
        currentTitle={title}
      />
    </LessonShell>
  );
};

export default ReadingPageLayout;